import React, { useEffect, useState} from "react";
import { useDispatch, useSelector } from "react-redux";







const CartIcon =  () => {

    let {cartItem}  = useSelector((state) => state.addToCart)
    //    let objLength = Object.getOwnPropertyNames(cartItem).length;

    return (
        <>
        <div className="cartIconWrapper">
             <div className="cartNotificationWraper">
                 <img src="/magimaart-icon-1.png"
                     className="cartImage"
                 />
                       <span className="cartNotification"
                          id="cartNotification"
                       >
                               {cartItem &&  Object.getOwnPropertyNames(cartItem).length > 0? 1 : 0 }
                     </span>
             </div>  
        </div>
        </>
    )
  }

  export default CartIcon;

  
